import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'

interface PageLayoutProps extends LayoutProps {
    className?: string
    withTabBar?: boolean
}

export const Layout: FC<PageLayoutProps> = ({ children, className, withTabBar = false }): ReactNode => {
    return (
        <main className={cn('flex min-h-full flex-col', withTabBar && 'pb-32', className)}>
            {children}
        </main>
    )
}
